/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summaryloadfailed2Inputs */

const en_summaryloadfailed2 = /** @type {(inputs: Summaryloadfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The recap could not be loaded.`)
};

const de_summaryloadfailed2 = /** @type {(inputs: Summaryloadfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Rückblick konnte nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "The recap could not be loaded." |
*
* @param {Summaryloadfailed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summaryloadfailed2 = /** @type {((inputs?: Summaryloadfailed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summaryloadfailed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summaryloadfailed2(inputs)
	return de_summaryloadfailed2(inputs)
});
export { summaryloadfailed2 as "summaryLoadFailed" }